<template lang="pug">
  .the-index-search-results
  PostsGrid( :query="{search: $route.query.q}" :limit="27" :show-filters="true" @indexPostsCount="setHasIndex" :index-search-results="true" :ssr="true")
</template>

<script setup lang="ts">
import PostsGrid from '@/js/pages/theindex/components/posts-grid.vue'

const emit = defineEmits<{(e: 'indexPostsCount', value: number): void}>()

function setHasIndex(value: number) {
  emit('indexPostsCount', value)
}
</script>

<style lang="scss" scoped>
  :deep(.empty-results-container) {
    border: none;
    padding-top: $space-s;
  }
</style>
